var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"nav-link",attrs:{"target":"_blank","href":"https://docs.pixelstrap.com/cuba/all_in_one/document/getting-started-vue.html"}},[_c('div',[_c('i',{staticClass:"icon-settings"})]),_c('span',[_vm._v("Document")])])
}]

export { render, staticRenderFns }